export const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

export const isIosOrMac = () => {
  return /iPhone|iPad|iPod|Macintosh/i.test(navigator.userAgent);
}